<template>
    <div class="system footer-margin do-not-translate">

        <div class="container footer-margin" v-html="body">

        </div>
    </div>
</template>

<script>
import Resource from '@/api/resource';
import { getFieldValues, showLoader, hideLoader } from '@/utils/helpers';

const contentResource = new Resource('contents');

export default {
    name: 'SystemContentView',
    data() {
        return {
            loader: null,
            content: null,
        }
    },
    watch: {
        routeName: function () {
            this.loadContent();
        }
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
        routeName() {
            return this.$route.name;
        },
        title() {
            if (this.content != null) {
                return this.content.title;
            }
            return "";
        },
        body() {
            var desc = getFieldValues(this.content, 'body');
            return desc != null ? desc : '';
        },
    },
    created() {
        this.loadContent();
    },
    methods: {
        showLoader,
        hideLoader,
        loadContent() {
            var id = this.getContentIdFromRouteName();
            if (id != null) {
                this.getContent(id);
            }
            window.scrollTo(0, 0);
        },
        getContentIdFromRouteName() {
            var id = null;
            switch (this.routeName) {
                case "Datenschutz":
                    id = this.$datenschutzContentId;
                    break;
                case "Impressum":
                    id = this.$impressumContentId;
                    break;
                case "Barrierefreiheitserklaerung":
                    id = this.$barrierefreiheitsContentId;
                    break;
                case "Gebaerdensprache":
                    id = "1811920";
                    break;
                default:
                    if (this.id !== null && this.id !== undefined) {
                        id = this.id;
                    }
                    break;
            }
            return id;
        },
        getContent(id) {
            this.loader = this.showLoader(this.loader);
            contentResource.get(id)
                .then(response => {
                    this.content = response.data;
                })
                .finally(() => {
                    this.loader = this.hideLoader(this.loader);
                });
        },
    },
}
</script>

<style lang="scss">
@import '@/scss/_variables.scss';

.system {
    position: relative;
    background: #fff;
    padding-top: 50px;
    padding-bottom: 20px;

    margin-bottom: calc(#{$footer-sm-size} + #{$mobile-menu-size});

    @media (max-width: 991px) {
        margin-bottom: #{$mobile-menu-size}
    }

    @media (max-width: 575px) {
        padding-top: 25px;
    }

    ul,
    li {
        margin: auto !important;
        text-decoration: auto !important;
        list-style: disc;
    }

    ul {
        padding-left: 40px;
    }

}
</style>
